import { useSelector, useDispatch } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './index';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Convenience selectors
export const useProducts = () => useAppSelector((state) => state.products);
export const useAnalyses = () => useAppSelector((state) => state.analyses);
export const useDashboard = () => useAppSelector((state) => state.dashboard);

// Specific selectors
export const useProductsLoading = () => useAppSelector((state) => state.products.loading);
export const useProductsError = () => useAppSelector((state) => state.products.error);
export const useSelectedProduct = () => useAppSelector((state) => state.products.selectedProduct);

export const useAnalysesLoading = () => useAppSelector((state) => state.analyses.loading);
export const useAnalysesError = () => useAppSelector((state) => state.analyses.error);
export const useSelectedAnalysis = () => useAppSelector((state) => state.analyses.selectedAnalysis);
export const useProcessingAnalysis = () => useAppSelector((state) => state.analyses.processingAnalysis);

export const useDashboardLoading = () => useAppSelector((state) => state.dashboard.loading);
export const useDashboardError = () => useAppSelector((state) => state.dashboard.error);
export const useDashboardStats = () => useAppSelector((state) => state.dashboard.stats);